module.exports = __webpack_public_path__ + "img/84.3.TP.d116c2c5.png";